import {Http, URLSearchParams, RequestOptions, Response} from '@angular/http';
import {IDataModel} from "../../services/IDataModel";
import {IDataFilter} from "../../services/DataTable";
import {NewClientsStatsModel} from "./new-clients-stats.model";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import * as moment from "moment";

export class NewClientsStatsService implements IDataModel {

    private API_ROOT:string = '/stats/new-clients';

    constructor(private http: Http) {}


    getList(filter?: IDataFilter) : Observable<ListResponseModel<NewClientsStatsModel>> {
        let params:URLSearchParams = new URLSearchParams();
        if (filter) {
            for (let key in filter) {
                params.set(key, filter[key]);
            }
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map((res) => {
                let response: ListResponseModel<NewClientsStatsModel> = res.json();

                response.data.forEach(function (val) {
                    val.date = moment(val.date);
                });

                return response;
            });
    }


    getOne(id: number) {
        return this.http.get(`${this.API_ROOT}/${id}`)
    }
}


// WEBPACK FOOTER //
// ./src/app/models/new-clients-stats/new-clients-stats.service.ts